import {LAYERURL} from './LayerUrlTypes'

export const addLayerUrl = layerUrl => {
    return {
        type: LAYERURL,
        load: layerUrl
    }
}